import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './i18n'; // Import i18n configuration
import { initializeApi } from './config/api';
import { getTelemetryConfig, validateTelemetryConfig } from './config/telemetry';
import { createContextLogger } from './utils/logger';

const logger = createContextLogger('main');

// Get and validate telemetry configuration
const telemetryConfig = getTelemetryConfig();
const validation = validateTelemetryConfig(telemetryConfig);

if (!validation.valid) {
  logger.warn('Telemetry configuration issues:', validation.errors);
}

// Initialize API layer with telemetry
initializeApi({
  enableLogging: import.meta.env.DEV, // Enable logging in development
  enableMonitoring: true,
  enableErrorTracking: true,
  enableTelemetry: telemetryConfig.enabled && telemetryConfig.backend.type !== 'disabled',
  environment: import.meta.env.MODE as 'development' | 'staging' | 'production',
  telemetry: {
    serviceName: telemetryConfig.serviceName,
    serviceVersion: telemetryConfig.serviceVersion,
    enableConsoleExporter: telemetryConfig.enableConsoleExporter,
    enableAutoInstrumentation: telemetryConfig.enableAutoInstrumentation,
    endpoint: telemetryConfig.backend.endpoint,
  },
});

// Log telemetry configuration in development
if (import.meta.env.DEV) {
  logger.info('🔍 Telemetry Configuration:', {
    enabled: telemetryConfig.enabled,
    backend: telemetryConfig.backend.type,
    endpoint: telemetryConfig.backend.endpoint,
    sampleRate: telemetryConfig.sampleRate,
    serviceName: telemetryConfig.serviceName,
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
